import React from 'react';
import styled from 'styled-components';
import { AnimatePresence } from 'framer-motion';
import MarkdownMessage from '../MarkdownMessage';
import TypingIndicator from '../TypingIndicator';
import QueueStatus from '../QueueStatus';
import { convertToLocalTime } from '../../utils/dateUtils';
import {
  ChatContainer,
  MessageWrapper,
  MessageContent,
  Avatar,
  Message,
  UserMessageContent,
  Timestamp
} from '../../styles/ChatStyles';

const ModalBackdrop = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 20px;
  cursor: pointer;
`;

const ModalContent = styled.div`
  position: relative;
  max-width: 90%;
  max-height: 90%;
  cursor: default;
  
  img {
    max-width: 100%;
    max-height: 80vh;
    width: auto;
    height: auto;
    border-radius: 8px;
    display: block;
  }
`;

const CloseButton = styled.button`
  position: absolute;
  top: -40px;
  right: 0;
  background: rgba(255, 255, 255, 0.9);
  border: none;
  border-radius: 6px;
  padding: 8px 16px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  color: #333;
  transition: all 0.2s;
  
  &:hover {
    background: #fff;
    transform: scale(1.05);
  }
`;

const ChatMessages = ({
  messages,
  isTyping,
  isLoadingHistory,
  config,
  chatContainerRef,
  bottomRef,
  handleScroll,
  modalImage,
  onImageClick,
  onCloseModal
}) => {
  return (
    <ChatContainer
      ref={chatContainerRef}
      onScroll={handleScroll}
    >
      {isLoadingHistory && (
        <div style={{ 
          textAlign: 'center', 
          padding: '10px', 
          color: '#65676b',
          fontSize: '13px'
        }}>
          Loading previous messages...
        </div>
      )}
      <AnimatePresence>
        {messages.map((message) => (
          <MessageWrapper
            key={message.id}
            sent={message.sent}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
          >
            <MessageContent>
              {!message.sent && (
                <Avatar src={config.chatbot_logo_url} alt="Bot Avatar" />
              )}
              <Message 
                sent={message.sent}
                isQueued={message.isQueued}
                userBackground={config.user_reply_background_color}
                botBackground={config.chatbot_reply_background_color}
              >
                {message.sent ? (
                  <UserMessageContent userTextColor={config.user_reply_text_color}>
                    {message.text}
                  </UserMessageContent>
                ) : (
                  <MarkdownMessage 
                    content={message.text} 
                    sent={message.sent}
                    onImageClick={onImageClick}
                  />
                )}
              </Message>
            </MessageContent>
            <Timestamp sent={message.sent}>
              {!message.isQueued && message.timestamp ? convertToLocalTime(message.timestamp) : ''}
            </Timestamp>
            <QueueStatus isQueued={message.isQueued} />
          </MessageWrapper>
        ))}
      </AnimatePresence>
      {isTyping && <TypingIndicator botAvatar={config.chatbot_logo_url} />}
      <div ref={bottomRef} />
      
      {modalImage && (
        <ModalBackdrop onClick={(e) => {
          if (e.target === e.currentTarget) {
            onCloseModal();
          }
        }}>
          <ModalContent onClick={(e) => e.stopPropagation()}>
            <CloseButton onClick={onCloseModal}>Close</CloseButton>
            <img src={modalImage} alt="Zoomed" />
          </ModalContent>
        </ModalBackdrop>
      )}
    </ChatContainer>
  );
};

export default ChatMessages;